.card {
  width: 100%;
  box-sizing: border-box;
  padding: var(--gac-space-md);
  border-radius: var(--gac-radius-md);
  background: var(--gac-surface-raised);
  border: 1px solid var(--gac-line-border);
}

/* The header carries the two things a status tracker is read for: where the order is, and when
   the next thing happens. Baymard: a tracker without an expected date is the top cause of
   distrust, so the second line is never empty when a date exists. */
.headline {
  border-bottom: 1px solid var(--gac-line-divider);
  padding-bottom: var(--gac-space-sm);
  margin-bottom: var(--gac-space-sm);
}

.toneProgress {
  color: var(--gac-accent);
}

.toneSuccess {
  color: var(--gac-status-success);
}

.toneDanger {
  color: var(--gac-status-danger);
}

.toneNeutral {
  color: var(--gac-text-secondary);
}

.steps {
  list-style: none;
  margin: 0;
  padding: 0;
}

/* Each row draws its own rail segment, so the line never runs past the last step. */
.step {
  position: relative;
  padding-left: var(--gac-space-lg);
  padding-bottom: var(--gac-space-md);
}

.step:last-child {
  padding-bottom: 0;
}

.step:not(:last-child)::before {
  content: '';
  position: absolute;
  left: 5px;
  top: 16px;
  bottom: 0;
  width: 2px;
  background: var(--gac-line-divider);
}

.marker {
  position: absolute;
  left: 0;
  top: 5px;
  width: 12px;
  height: 12px;
  border-radius: var(--gac-radius-pill);
  box-sizing: border-box;
  border: 2px solid var(--gac-line-border);
  background: var(--gac-surface-base);
}

.markerDone {
  background: var(--gac-status-success);
  border-color: var(--gac-status-success);
}

/* The current step is the one the eye should land on: filled, accent, and slightly larger than
   the rest of the rail. */
.markerCurrent {
  background: var(--gac-accent);
  border-color: var(--gac-accent);
  width: 14px;
  height: 14px;
  left: -1px;
  top: 4px;
}

.markerException {
  background: var(--gac-status-danger);
  border-color: var(--gac-status-danger);
}

.future {
  opacity: 0.55;
}

.notes {
  margin-top: var(--gac-space-xxs);
  padding-left: var(--gac-space-sm);
  border-left: 2px solid var(--gac-line-divider);
}

.link {
  color: var(--gac-accent);
  text-decoration: none;
}

.link:hover {
  text-decoration: underline;
}
